import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenProceduresIndicatorB5 } from "@/services/esus/indicator/esb/b5/getDetailedCitizenProceduresIndicatorB5";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB5DentalAttendanceProceduresHistoryItem } from "./IndicatorEsbB5DentalProcedureHistoryItem";
import { IndicatorEsbB5CitizenHistoryInfo } from "./IndicatorEsbB5CitizenHistoryInfo";
import { timeDimensionToString } from "@/utils/dateUtil";

type IndicatorEsbB5CitizenAttendancesHistoryProps = {
	citizenWithDentalAttendanceProcedures: DetailedCitizenProceduresIndicatorB5;
};

export function IndicatorEsbB5CitizenAttendancesHistory({
	citizenWithDentalAttendanceProcedures,
}: Readonly<IndicatorEsbB5CitizenAttendancesHistoryProps>) {
	const indicatorEsbB5CitizenHistoryInfo = {
		fullName: citizenWithDentalAttendanceProcedures.fullName
			? citizenWithDentalAttendanceProcedures.fullName
			: "N/A",
		birthdate: citizenWithDentalAttendanceProcedures.birthdate
			? dayjs(citizenWithDentalAttendanceProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithDentalAttendanceProcedures.cpf
			? formatIdentifier(citizenWithDentalAttendanceProcedures.cpf)
			: citizenWithDentalAttendanceProcedures.cns ?? "",
		motherName: citizenWithDentalAttendanceProcedures.motherName ?? "",
		phone: citizenWithDentalAttendanceProcedures.phone
			? phoneFormat(citizenWithDentalAttendanceProcedures.phone)
			: "",
		address:
			addressConcat(
				citizenWithDentalAttendanceProcedures.street,
				citizenWithDentalAttendanceProcedures.houseNumber,
				citizenWithDentalAttendanceProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB5CitizenHistoryInfo {...indicatorEsbB5CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Procedimentos Odontológicos"
				timeLineContents={(
					citizenWithDentalAttendanceProcedures.dentalAttendanceProcedures ?? []
				).map<TimeLineContent>((dentalAttendanceProcedure) => {
					return {
						content: (
							<IndicatorEsbB5DentalAttendanceProceduresHistoryItem
								dentalAttendanceProcedure={dentalAttendanceProcedure}
							/>
						),
						eventDate:
							timeDimensionToString(dentalAttendanceProcedure.timeDimensionId) ||
							"N/A",
					};
				})}
			/>
		</>
	);
}
